import instamapsHeader from './shared/components/header/header.vue';
import instamapsGallery from './gallery/gallery.vue';
import instamapsLogin from './login/login.vue';
import instamapsRegistre from './registre/registre.vue';
import instamapsOblidat from './oblidat/oblidat.vue';
import instamapsRenovar from './renovar/renovar.vue';
import instamapsFooter from './shared/components/footer/footer.vue';
import instamapsLoader from './shared/components/loader/loader.vue';
import {LoginService} from './login/services/loginService';
import {AuthService} from './login/services/authService.js';
import { ApplicationConstants } from './shared/applicationConstants';
import * as $ from 'jquery';

export default {
    name: 'galleryApp',
    components: {
        instamapsHeader,
        instamapsGallery,
        instamapsLogin,
        instamapsOblidat,
        instamapsRenovar,
        instamapsRegistre,
        instamapsFooter,
        instamapsLoader,
    },
    data() {
        return {
            isLoading: false,
            selectedLang: '',
            hasBreadcrumbs: true,
            hasToShowMobileMenu: undefined,
            isUserLogged: false,
        };
    },
    computed: {
        isViewer: function () {
            return (this.$route.name === 'viewer') ? true : false;
        },
    },
    methods: {
        showLoader: function () {
            this.isLoading = true;
        },
        hideLoader: function () {
            this.isLoading = false;
        },
        showMobileMenu: function (value) {
            this.hasToShowMobileMenu = value;
        },
        langChange: function (value) {
            this.$parent.$emit('langchanged', value);
            this.selectedLang = value;
        },
        hideLanguageSelector: function () {
            $('#language-selector').removeClass('show-language-menu');
        },
        hideMenuMain: function () {
            this.hideLanguageSelector();
            $('#menu-top').removeClass('menu-animation-in');
        },
        userLogin: function(data){
           this.isUserLogged= true;
           //comprovar si és col·laboratiu o bé de random
            //COL·LABORATIU
            if (AuthService.getCollaborateBid()) {
                if (AuthService.getCollaborateUid()){
                    if (AuthService.getCollaborateUid()!=AuthService.getUid()) {
                            alert("No pots donar d'alta el mapa col·laboratiu perquè els usuaris no són iguals");
                            this.redirectProfile(); //redirigim al profile
                            AuthService.deleteCollaborateBid();
                            AuthService.deleteCollaborateUid();
                        }
                    else {
                            //redirigim a la pàgina del visor
                           window.location = ApplicationConstants.visorUrl + 'businessid='+AuthService.getCollaborateBid()+'&uid='+AuthService.getCollaborateUid()+'&mapacolaboratiu=alta';                         
                        }
                    }
                    else {
                        //redirigim al visor i esborrem cookies
                        window.location = ApplicationConstants.visorUrl + 'businessid='+AuthService.getCollaborateBid()+'&uid='+AuthService.getCollaborateUid()+'&mapacolaboratiu=alta';
                        AuthService.deleteCollaborateBid();
                        AuthService.deleteCollaborateUid();
                    }
            }
            else {
                if (data !== undefined && data.mapBusinessId !== undefined) { //venim de mapa random i fem login
                    window.location = ApplicationConstants.newMapUrl + 'businessid='+data.mapBusinessId;
                }
                else {
                    this.redirectProfile();
                }
           }
        },
        isLogged: function(){
            this.isUserLogged = LoginService.isUserLogged();
        },
        userLogout: function(){
            LoginService.httpPostLogout().then((response) => {
                if (response.status==="OK") {
                    this.isUserLogged = false;
                    this.redirectHome();
                }else{
                    this.isUserLogged = false;
                    this.redirectHome();
                }
            }).catch(() => {
                this.isUserLogged = false;
                this.redirectHome();
            });
        },
        redirectLogin: function(){
            this.hideLoader();
            this.$router.push('/login');
        },
        redirectProfile: function(){
            this.hideLoader();
            this.$router.push('/perfil');
        },
        redirectHome: function(){
            this.hideLoader();
            this.$router.push('/');
        }        
    },
    mounted() {
        $('.back-to-top').on('click', () => {
            $('#scroller').animate({
                scrollTop: 0,
            }, 1000);
        });
       this.isLogged();
    },
};

$(document).ready(function () {
    $('#scroller').scroll(() => {
        var featuredOffset = $('.featured').outerHeight();
        var vOffset;
        var searchBoxOffset = $('.search-box').outerHeight();
        if ($('.page-title').css('display') === 'none') {
            vOffset = featuredOffset;
        } else {
            vOffset = featuredOffset + 40;
        }
        $('.search-box').toggleClass('sticky', $('#scroller').scrollTop() > vOffset);
        $('#items').css('margin-top', ($('.search-box').hasClass('sticky') && $('#scroller').scrollTop() > vOffset) ? searchBoxOffset : 0);
    });
});



// WEBPACK FOOTER //
// ./src/App.js